import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as invoiceExtractActions from 'store/modules/invoiceExtract/actions'
import { extractOriginalContractNumber } from 'helpers/tools'
import { Container, Row, Col, Spinner } from 'react-bootstrap'
import Typography from 'components/atoms/Typography'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import CustomModal from 'components/molecules/CustomModal'
import IconPDF from 'assets/img/icone-pdf.png'
import 'styles/responsive-table.scss'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './BoletoExtrato.scss'


function BoletoExtrato(props) {
  const dispatch = useDispatch()
  const { data, user } = props
  let contract = user?.contract || ''
  const session = useSelector((state) => state?.auth?.user)
  const [cardNumber, setCardNumber] = useState('')
  const [showError, setShowError] = useState(false)

  if (!contract && session?.contract) {
    contract = session?.contract
  }

  const invoiceExtract = useSelector((state) => state?.invoiceExtract)

  useEffect(() => {
    setCardNumber(extractOriginalContractNumber(contract))
  }, [contract])

  useEffect(() => {
    if (cardNumber && invoiceExtract) {
      const contract = cardNumber
      dispatch(invoiceExtractActions.getInvoiceExtract(contract))
    }
  }, [cardNumber])

   useEffect(() => {
    if (invoiceExtract?.error) {
      toggleVisibilityModalError(true)
    }
  }, [invoiceExtract?.error])

  const toggleVisibilityModalError = (open) => {
    if (open) {
      setShowError(true)
    } else {
      setShowError(false)
    }
  }
  
  const renderTableItems = (items) => {
    if (!items || items.length === 0) return null

    return items
      .map((item, index) => (
        <Tr key={index}>
          <Td className="text-gray-100">{item?.number}</Td>
          <Td className="text-gray-100">{item?.dueDate}</Td>
          <Td className="text-center">
            <div className="invoice-extract__report--done">
              <a href={item?.linkPdf} target="_blank" rel="noopener noreferrer" title="Baixar fatura">
                <img src={IconPDF} alt="ícone de representação de um arquivo PDF" />
              </a>
            </div>
          </Td>
        </Tr>
      ))
  }

  return (
    <Container className="mt-5 mb-5">
      <Row>
        <Col>
          <Typography
            variant="h2"
            color="primary"
            cssClass="invoice-extract__title title-semibold-md mb-3"
          >
            {data?.title || 'Fatura'}
          </Typography>
        </Col>
      </Row>

      <Row>
        <Col>
          {invoiceExtract?.loading && (
            <Spinner animation="border" />
          )}
          {!invoiceExtract?.loading && !invoiceExtract?.error && invoiceExtract?.data && invoiceExtract.data.length > 0 ? (
            <Table className="responsive-table invoice-extract__process">
              <Thead>
                <Tr>
                  <Th>Número</Th>
                  <Th>Data de Vencimento</Th>
                  <Th className="text-center">Download</Th>
                </Tr>
              </Thead>
              <Tbody>{renderTableItems(invoiceExtract?.data)}</Tbody>
            </Table>
          ) : null}
          {!invoiceExtract?.loading && !invoiceExtract?.error && (!invoiceExtract?.data || invoiceExtract.data.length === 0) && (
            <Typography
              variant="p"
              color="gray-100">
              Não há faturas disponíveis
            </Typography>
          )}
        </Col>
      </Row>

      <CustomModal
          open={showError}
          closeModal={() => toggleVisibilityModalError(false)}
          size="sm"
          title="Fatura"
          footer={{ closeButton: true }}
        >
          <Typography variant="p" color="danger">
            Erro ao buscar faturas: {invoiceExtract?.error?.error || invoiceExtract?.error}
          </Typography>
        </CustomModal>
    </Container>
  )
}

export default BoletoExtrato
